<template>
  <page>
    <template slot="content">
      <help-content :title="'ホームの距離値が反映されない理由は？'">
        <template slot="content">
          <div class="text">
            ホーム画面に表示されている距離は歩数と歩幅によって計算した値です。「ウォーク/ラン」機能を利用して記録したデータのみがGPSウォーク／ランイベントの対象データとなります。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help15.vue